import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';
import cart from "./cart";
import quantity from "./quantity-input";
import redirect from "./redirect";
import availability from "./availability";
import newsletter from "./newsletter";
import shopFilters from "./shop-filters";
import addToCartPopup from "./add-to-cart-popup";
import slidingCart from "./sliding-cart";
import customerOpinions from "./customer-opinions";
import templateBenefit from "./template-benefit";
import loginPopup from "./login-popup";
import foreignCheckout from "./foreign-checkout";
import assistant from "./assistant";
import presort from "./presort";
import accordionBackground from "./accordion-background";
import motion from "./motion";
class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
        });
    };

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            cart.init();
            quantity.init();
            cart.updateMiniCart();
            cart.dropdownCart();
            redirect.init();
            availability.availabilityNotification();
            newsletter.newsletter();
            shopFilters.init();
            addToCartPopup.init();
            slidingCart.init();
            customerOpinions.init();
            templateBenefit.init();
            loginPopup.init();
            foreignCheckout.init();
            assistant.init();
            presort.init();
            accordionBackground.init();
        });
        document.addEventListener("DOMContentLoaded", () => motion.init());

    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {
        });
    }

}

new Main();


